import script from "./RecruitmentAnnouncementDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./RecruitmentAnnouncementDetail.vue?vue&type=script&setup=true&lang=js"

import "./RecruitmentAnnouncementDetail.vue?vue&type=style&index=0&id=35a0f19c&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enterpriseprodex/sxpf-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a0f19c"]])

export default __exports__